import { createContext, useContext } from 'react'

import {
  OnboardingDocumentsDetailsWebPage,
  OnboardingDocumentsDetailsWebPageOptions
} from 'commons/types/DTO/bank/applications/onboardingDocuments'

type SetupDocumentsViewDetailsContextValue = {
  data: OnboardingDocumentsDetailsWebPage
  isPending: boolean
  successFullyLoaded: boolean
  invalidate: () => void
  search: OnboardingDocumentsDetailsWebPageOptions
  clear: () => void
}

export const SetupDocumentsViewDetailsContext = createContext<SetupDocumentsViewDetailsContextValue | null>(null)

export const useSetupDocumentsViewDetailsContext = () => {
  const context = useContext(SetupDocumentsViewDetailsContext)

  if (!context) {
    throw new Error(
      'useSetupDocumentsViewDetailsContext must be used within a SetupDocumentsViewDetailsContext.Provider'
    )
  }

  return context
}
